import type {
  WeighDirection,
  WeighStage,
  WeighbridgeFlowIdentity,
} from '../types'

export interface FlowIdentityInput extends WeighbridgeFlowIdentity {
  stage?: WeighStage
}

export function getFlowDirection(
  identity: WeighbridgeFlowIdentity | null | undefined,
): WeighDirection {
  return identity?.direction === 'inbound' ? 'inbound' : 'outbound'
}

export function getFlowIdentifier(
  identity: WeighbridgeFlowIdentity | null | undefined,
): string {
  if (!identity) return ''
  if (getFlowDirection(identity) === 'inbound') {
    return identity.shipmentNumber ?? ''
  }
  return identity.orderNumber ?? ''
}

export function getFlowQueueKey(
  identity: WeighbridgeFlowIdentity | null | undefined,
): string {
  const direction = getFlowDirection(identity)
  return `${direction}:${getFlowIdentifier(identity)}`
}

export function buildFlowIdentity(
  value: string,
  direction: WeighDirection,
): WeighbridgeFlowIdentity {
  const trimmed = value.trim()
  if (direction === 'inbound') {
    return { direction, shipmentNumber: trimmed }
  }
  return { direction, orderNumber: trimmed }
}

export function isSameFlowIdentity(
  left: WeighbridgeFlowIdentity,
  right: WeighbridgeFlowIdentity,
): boolean {
  const leftKey = getFlowQueueKey(left)
  const rightKey = getFlowQueueKey(right)
  return leftKey !== '' && leftKey === rightKey
}

export function hasFlowIdentifier(
  identity: WeighbridgeFlowIdentity | null | undefined,
): boolean {
  return getFlowIdentifier(identity).length > 0
}
